import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import ProfileReaction from './profile-reaction-model'
import {
  CreateProfileReactionAsync,
  DeleteProfileReactionAsync,
  LoadProfileReactionsAsync,
} from './profileReaction-thunk'
const initialState: profileReactionSliceState = {
  profileReaction: [],
  selected_profileReaction: '',
  is_loading_profileReaction: false,
  is_creating_profileReaction: false,
  is_deleting_profileReaction: false,
}
export interface profileReactionSliceState {
  profileReaction: ProfileReaction[]
  selected_profileReaction?: string
  is_loading_profileReaction: boolean
  is_creating_profileReaction: boolean
  is_deleting_profileReaction: boolean
}
export const profileReactionSlice = createSlice({
  name: 'profileReaction',
  initialState,
  reducers: {
    setSelectedprofileReaction: (state, action) => {
      state.selected_profileReaction = action.payload
    },
    clearStateprofileReaction: (state) => {
      state.profileReaction = []
      state.is_loading_profileReaction = false
      state.is_creating_profileReaction = false
      state.is_deleting_profileReaction = false
    },
    mergeprofileReaction: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_profileReaction = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.profileReaction = merge(state.profileReaction, payload) as any
        }
      }
    },

    add_profileReaction: (state, action) => {
      if (action.payload) {
        state.profileReaction = [...state.profileReaction, action.payload]
      }
    },
    set_profileReaction: (state, action) => {
      let { key, value, id } = action.payload
      state.profileReaction = state.profileReaction.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadProfileReactionsAsync.pending, (state) => {
      state.is_loading_profileReaction = true
    })
    builder.addCase(LoadProfileReactionsAsync.fulfilled, (state, action) => {
      state.is_loading_profileReaction = false
      if (action.payload) {
        state.profileReaction = action.payload
      }
    })
    builder.addCase(LoadProfileReactionsAsync.rejected, (state) => {
      state.is_loading_profileReaction = false
    })
    builder.addCase(CreateProfileReactionAsync.pending, (state) => {
      state.is_creating_profileReaction = true
    })
    builder.addCase(CreateProfileReactionAsync.fulfilled, (state) => {
      state.is_creating_profileReaction = false
    })
    builder.addCase(CreateProfileReactionAsync.rejected, (state) => {
      state.is_creating_profileReaction = false
    })
    builder.addCase(DeleteProfileReactionAsync.pending, (state) => {
      state.is_deleting_profileReaction = true
    })
    builder.addCase(DeleteProfileReactionAsync.fulfilled, (state, action) => {
      state.is_deleting_profileReaction = false
      if (state.profileReaction) {
        state.profileReaction = state.profileReaction.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteProfileReactionAsync.rejected, (state) => {
      state.is_deleting_profileReaction = false
    })
  },
})

export const {
  clearStateprofileReaction,
  setSelectedprofileReaction,
  set_profileReaction,
  mergeprofileReaction,
  add_profileReaction,
} = profileReactionSlice.actions

export const get_profileReaction =
  (id?: string) =>
  (state: {
    profileReaction: {
      profileReaction: ProfileReaction[]
    }
  }): ProfileReaction | null => {
    let temp = state?.profileReaction?.profileReaction?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.profileReaction?.profileReaction[0] || null
  }
export const get_selected_profileReaction = (state: {
  profileReaction: profileReactionSliceState
}): ProfileReaction | null => {
  let id = state?.profileReaction?.selected_profileReaction
  let temp = state?.profileReaction?.profileReaction?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_profileReaction = (state: {
  profileReaction: {
    profileReaction: ProfileReaction[]
  }
}): ProfileReaction[] => {
  let temp = state?.profileReaction?.profileReaction
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_profileReaction_busy = (state: {
  profileReaction: profileReactionSliceState
}) => {
  return (
    state?.profileReaction.is_deleting_profileReaction ||
    state?.profileReaction.is_loading_profileReaction ||
    state?.profileReaction.is_creating_profileReaction
  )
}
export const is_deleting_profileReaction_busy = (state: {
  profileReaction: profileReactionSliceState
}) => {
  return state?.profileReaction.is_deleting_profileReaction
}
export const is_loading_profileReaction_busy = (state: {
  profileReaction: profileReactionSliceState
}) => {
  return state?.profileReaction.is_loading_profileReaction
}
export const is_creating_profileReaction_busy = (state: {
  profileReaction: profileReactionSliceState
}) => {
  return state?.profileReaction.is_creating_profileReaction
}

export default profileReactionSlice.reducer
